import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { TypedMemo } from '../../common/types';
import styles from './SMLPublishedHeader.module.scss';

interface SMLPublishedHeaderProps {
  /** Mono context label — what kind of page just went up. */
  label: string;
  onClose: () => void;
}

/** The strip across the top: the state, the context, the way out. */
const SMLPublishedHeaderComponent: React.FC<SMLPublishedHeaderProps> = ({ label, onClose }) => {
  const intl = useIntl();

  return (
    <div className={styles.strip}>
      <span className={styles.livePill}>
        <i className={styles.dot} />
        {intl.formatMessage({ id: 'app.sml.published.live', defaultMessage: 'Live' })}
      </span>
      <span className={styles.label}>{label}</span>
      <button
        type="button"
        className={styles.close}
        onClick={onClose}
        aria-label={intl.formatMessage({ id: 'app.sml.published.close', defaultMessage: 'Close' })}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
};

export const SMLPublishedHeader = TypedMemo(SMLPublishedHeaderComponent);
